import angular from 'angular';
import { pull } from 'lodash';
import moment from 'moment-timezone';

const ZONE_NAMES = [
  "America/Los_Angeles",
  "America/Phoenix",
  "America/Chicago",
  "America/New_York",
];

const FORMAT = 'YYYY-MM-DD H:mm a';
const ZONES = ZONE_NAMES.map(function(z) { return moment.tz.zone(z); });

module.exports = angular.module('common.components.human-schedules.od-unavailabilities-table', [
])
.directive('odUnavailabilitiesTable', () => {
  return {
    restrict: 'E',
    scope: {
      human: '=',
      unavailabilities: '=',
    },
    template: require('./od-unavailabilities-table.jade'),
    bindToController: true,
    controllerAs: '$ctrl',
    controller: UnavailabilitiesCtrl
  };
})
.name;

class UnavailabilitiesCtrl {
  // @ngInject
  constructor($scope, AvailableTimes, HumanUnavailability) {
    this.HumanUnavailability = HumanUnavailability;
    this.TIMES = AvailableTimes;
    this.ZONES = ZONES;

    $scope.$watch('$ctrl.human.id', () => this.resetNewUnavailability());
  }

  deleteUnavailability(unavailability) {
    unavailability.$delete().then(() => {
      pull(this.unavailabilities, unavailability);
    });
  }

  resetNewUnavailability() {
    if (!this.human) return;

    this.newUnavailability = new this.HumanUnavailability({
      human_id: this.human.id,
      timezone: moment.tz.guess()
    });
  }

  saveNewUnavailability() {
    let un = this.newUnavailability;

    un.start_time = moment.tz(
        `${un._startDate} ${un._startTime}`,
        FORMAT,
        un.timezone
      ).toISOString();
    un.finish_time = moment.tz(
        `${un._finishDate} ${un._finishTime}`,
        FORMAT,
        un.timezone
      ).toISOString();

    un.$save().then( () => {
      this.unavailabilities.push(un);
      this.resetNewUnavailability();
    });
  }
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/human-schedules/od-unavailabilities-table.js
 **/